@if (photos.length || documents.length) {
  <div class="ai-composer__thumbs">
    @for (photo of photos; track $index) {
      <div class="ai-composer__thumb">
        <img [src]="photo" alt="Photo à envoyer" />
        <button class="ai-chat__icon-btn" (click)="removePhoto($index)" title="Retirer la photo">
          <i class="pi pi-times"></i>
        </button>
      </div>
    }
    @for (document of documents; track $index) {
      <eva-tag
        class="ai-composer__document"
        [label]="document.nom"
        icon="heroDocumentText"
        severity="secondary"
        [removable]="true"
        (onRemove)="removeDocument($index)"
      />
    }
  </div>
}

<input
  #fileInput
  type="file"
  accept="image/*,application/pdf,.xlsx,.csv,.eml,message/rfc822"
  multiple
  hidden
  (change)="onFilesPicked($event)"
/>
<!-- Saisie en carte (maquette B) : texte au-dessus, outils dessous, coût ou avertissement du mode auto sous la carte. -->
<div class="ai-composer__card" [class.ai-composer__card--dragging]="dragging" [class.ai-composer__card--auto]="auto()">
  <textarea
    class="ai-hero__input ai-composer__textarea"
    rows="1"
    [(ngModel)]="draft"
    [placeholder]="
      dragging
        ? 'Déposez vos PDF, e-mails, photos ou tableurs'
        : recording
          ? 'Enregistrement… cliquez sur stop pour transcrire'
          : placeholder
    "
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
  ></textarea>

  <div class="ai-composer__tools">
    <button
      type="button"
      class="ai-composer__tool"
      title="Joindre des PDF, des e-mails (.eml), des photos ou un tableur Excel / CSV (ou glissez-les, ou collez une capture ici)"
      [disabled]="busy || full"
      (click)="pickFiles()"
    >
      <i class="pi pi-paperclip"></i>
    </button>

    <div class="ai-composer__mode" role="group" aria-label="Application des modifications de l'assistant">
      <button
        type="button"
        [attr.aria-pressed]="!auto()"
        title="Chaque modification vous est proposée avant d'être appliquée"
        (click)="onAutoChange(false)"
      >
        Valider
      </button>
      <button
        type="button"
        class="ai-composer__mode-auto"
        [attr.aria-pressed]="auto()"
        title="Les modifications s'appliquent sans votre validation"
        (click)="onAutoChange(true)"
      >
        <ng-icon name="heroBolt" size="13px" />
        Auto
      </button>
    </div>

    <div class="ai-composer__end">
      @if (level) {
        <eva-popover #levelPopover position="bottom" align="end" [showArrow]="false" width="300px" appendTo="body">
          <button
            trigger
            type="button"
            class="ai-level__trigger"
            [attr.aria-expanded]="levelPopover.isVisible"
            [disabled]="busy || !!lockedModel"
            [title]="
              (lockedModel ? 'Niveau de cette conversation' : 'Niveau de l\'assistant') + ' · ' + level.description
            "
          >
            <span>{{ level.label }}</span>
            <span class="ai-level__gauge" [attr.aria-label]="level.description">
              @for (dot of gauge; track dot) {
                <i [class.ai-level__dot--on]="dot <= (level.cout ?? 0)"></i>
              }
            </span>
            @if (!lockedModel) {
              <i class="pi pi-chevron-down ai-level__chevron"></i>
            }
          </button>
          <div content class="ai-level__list" role="listbox" aria-label="Niveau de l'assistant">
            <p class="ai-level__heading">Niveau de l'assistant</p>
            @for (m of models; track m.name) {
              <button
                type="button"
                role="option"
                class="ai-level__option"
                [class.ai-level__option--active]="m.name === level.name"
                [attr.aria-selected]="m.name === level.name"
                (click)="onModelChange(m.name); levelPopover.hide()"
              >
                <span class="ai-level__label">{{ m.label }}</span>
                <i class="pi pi-check ai-level__check" aria-hidden="true"></i>
                <span class="ai-level__cost">
                  <span class="ai-level__gauge">
                    @for (dot of gauge; track dot) {
                      <i [class.ai-level__dot--on]="dot <= (m.cout ?? 0)"></i>
                    }
                  </span>
                  {{ m.description }}
                </span>
              </button>
            }
          </div>
        </eva-popover>
      }
      <button
        type="button"
        class="ai-composer__tool"
        [class.ai-composer__tool--recording]="recording"
        [title]="recording ? 'Arrêter et transcrire' : 'Dicter un message'"
        [disabled]="busy || transcribing"
        (click)="toggleRecording()"
      >
        @if (transcribing) {
          <i class="pi pi-spin pi-spinner"></i>
        } @else {
          <i class="pi" [class.pi-stop-circle]="recording" [class.pi-microphone]="!recording"></i>
        }
      </button>
      @if (busy) {
        <button class="ai-composer__send" type="button" title="Arrêter la réflexion" (click)="stopped.emit()">
          <i class="pi pi-stop"></i>
        </button>
      } @else {
        <button class="ai-composer__send" type="button" title="Envoyer" [disabled]="!canSend" (click)="send()">
          <i class="pi pi-arrow-up"></i>
        </button>
      }
    </div>
  </div>
</div>

<p class="ai-composer__note" [class.ai-composer__note--auto]="auto()" role="status">
  @if (auto()) {
    Mode auto : l'assistant applique ses modifications sans vous demander.
  } @else {
    @if (usageLabel) {
      {{ usageLabel }} ·
    }
    Propulsé par IA souveraine · Données hébergées en Suisse
  }
</p>
